<div class="procedure-report-dialog">
  <div class="dialog-header">
    <mat-icon>healing</mat-icon>
    <div>
      <h2>{{ title }}</h2>
      <p>Procedure report</p>
    </div>
  </div>

  <div mat-dialog-content class="dialog-body" [formGroup]="form">
    <div class="field-grid">
      <mat-form-field appearance="outline">
        <mat-label>Performed</mat-label>
        <input matInput type="datetime-local" formControlName="performedDateTime" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option value="preparation">Preparation</mat-option>
          <mat-option value="in-progress">In progress</mat-option>
          <mat-option value="on-hold">On hold</mat-option>
          <mat-option value="completed">Completed</mat-option>
          <mat-option value="stopped">Stopped</mat-option>
          <mat-option value="not-done">Not done</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Outcome</mat-label>
      <textarea matInput rows="3" formControlName="outcome"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Complications</mat-label>
      <textarea matInput rows="3" formControlName="complications"></textarea>
      <mat-hint>One complication per line</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Follow up</mat-label>
      <textarea matInput rows="3" formControlName="followUp"></textarea>
      <mat-hint>One follow-up item per line</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Notes</mat-label>
      <textarea matInput rows="4" formControlName="note"></textarea>
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Close</button>
    @if (!readOnly) {
    <button mat-stroked-button type="button" (click)="saveDraft()" [disabled]="saving">
      Save Draft
    </button>
    <button mat-flat-button color="primary" type="button" (click)="saveFinal()" [disabled]="saving">
      Save Final
    </button>
    }
  </div>
</div>
